module.exports = __webpack_public_path__ + "img/xgaltool_new.8377555f.jpg";